/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mcp_Formats_LabelInputs */

const en_mcp_formats_label = /** @type {(inputs: Mcp_Formats_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formats`)
};

const es_mcp_formats_label = /** @type {(inputs: Mcp_Formats_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formatos`)
};

/**
* | output |
* | --- |
* | "Formats" |
*
* @param {Mcp_Formats_LabelInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mcp_formats_label = /** @type {((inputs?: Mcp_Formats_LabelInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mcp_Formats_LabelInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mcp_formats_label(inputs)
	return en_mcp_formats_label(inputs)
});